/**
 * pages/Dashboard.tsx
 *
 * Rewritten from scratch (Apr 2026) following Calm Design and Strategic Minimalism
 * principles. The dashboard is purely informational - no duplicate actions from
 * other pages. Two sections: activity summary (KPIs + to-review list) and a
 * read-only overview of recent form templates.
 * All data is fetched in parallel via Promise.all.
 * Updated (Apr 2026): removed subtitle, removed "En attente" KPI.
 * Updated (Apr 2026): dynamic time-of-day greeting with emoji via getGreeting().
 * Updated (Apr 2026): added per-query error handling for Promise.all results;
 * stabilised greeting computation with useMemo.
 * Updated (Apr 2026): greeting title uses Playfair Display serif font-medium via titleClassName prop.
 * Updated (Apr 2026): extracted shared TITLE_CLASSNAME constant to avoid drift between render paths.
 * Updated (Apr 2026): both loading and main render branches now use TITLE_CLASSNAME (no hardcoded strings).
 * Updated (Apr 2026): "Mes formulaires" now uses useUserForms hook so it shows both owned and
 * admin-assigned forms (aligned with the Formulaires page behaviour).
 * Updated (Apr 2026): forms loading is no longer part of the global gate; the activity card
 * renders immediately while DashboardFormsOverview handles its own localised spinner.
 * Updated (Apr 2026): DashboardOnboardingCard added at the top to nudge new users to
 * configure their logo and stamp.
 * Updated (Apr 2026): admin users see AdminHomeDashboard (analytics monitoring). Split into
 * two components to avoid hooks-after-conditional-return violations.
 * Updated (Jun 2026): uses effectiveIsAdmin from useEffectiveUser so that during impersonation
 * the admin sees UserDashboard (the target user's view) instead of AdminHomeDashboard.
 */

import { useEffectiveUser } from '../hooks/useEffectiveUser';
import AdminHomeDashboard from './admin/AdminHomeDashboard';
import UserDashboard from '../components/dashboard/UserDashboard';

export default function Dashboard() {
  const { effectiveIsAdmin } = useEffectiveUser();

  if (effectiveIsAdmin) {
    return <AdminHomeDashboard />;
  }

  return <UserDashboard />;
}
